import { useGoogleLogin } from "@react-oauth/google";
import { Suspense, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { loginWithGoogle, register } from "../../data/sign-up/signUpSlice";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { useFormik } from "formik";
import { jwtDecode } from "jwt-decode";
import { gapi } from "gapi-script";
import GoogleLogin from "react-google-login";

const clientId =
  "263736580748-di1finbitm46nff8hrbekfgbudb7iul8.apps.googleusercontent.com"; // Replace with your actual Client ID
function SignUp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const accessToken = useSelector((store) => store.register.token);
  const message = useSelector((store) => store.register.message);
  const loading = useSelector((store) => store.register.loading);
  const [passwordType, setPasswordType] = useState("password");
  const [repasswordType, setRepasswordType] = useState("password");
  const [rePass, setRePass] = useState("");
  // const [recaptchaToken, setRecaptchaToken] = useState(null);

  // useEffect(() => {
  //   const loadGapi = () => {
  //     return new Promise((resolve, reject) => {
  //       window.gapi.load("client:auth2", () => {
  //         window.gapi.client
  //           .init({
  //             clientId: clientId,
  //             scope: "profile email",
  //           })
  //           .then(() => {
  //             console.log("gapi initialized");
  //             resolve();
  //           })
  //           .catch((error) => {
  //             console.error("Error initializing gapi:", error);
  //             reject(error);
  //           });
  //       });
  //     });
  //   };

  //   loadGapi().catch((error) => {
  //     console.error("Failed to load gapi:", error);
  //   });
  // }, []);

  const onSuccess = async (response) => {
    const idToken = response.getAuthResponse().id_token;

    dispatch(loginWithGoogle(idToken));
    localStorage.setItem("firstName", response.wt.rV);
    localStorage.setItem("lastName", response.wt.uT);
    localStorage.setItem("email", response.wt.cu);
    localStorage.setItem("userImage", response.wt.hK);
    navigate("/");
    // try {
    //   const apiEndpoint =
    //     "https://api.travco.com/apiTITSol/TTG24_User/LoginWithGoogle";
    //   const response = await fetch(apiEndpoint, {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({ idToken: idToken }),
    //   });

    //   if (response.ok) {
    //     const data = await response.json();
    //     console.log("API Response:", data);

    //   } else {
    //     const errorData = await response.json();
    //     console.error(`API Error: ${errorData.message}`);
    //   }
    // } catch (error) {
    //   console.error("Error calling API:", error);
    // }
  };

  const onFailure = (error) => {
    console.error("Login Failed:", error);
  };

  // const onSuccess = (response) => {
  //   console.log("Login Success:", response);
  //   dispatch(loginWithGoogle(response.tokenId));
  // };

  // const onFailure = (response) => {
  //   console.log("Login Failed:", response);
  // };

  // const { googleLogin } = useGoogleLogin({
  //   onSuccess,
  //   onFailure,
  //   clientId,
  //   isSignedIn: true,
  //   accessType: "offline",
  // });

  // useEffect(() => {
  //   if (accessToken) {
  //     localStorage.setItem("accessToken", accessToken);
  //     navigate("/");
  //   }
  // }, [accessToken, navigate]);

  // useEffect(() => {
  //   const storedToken = localStorage.getItem("userToken");
  //   if (storedToken) {
  //     dispatch({
  //       type: "register/userRegister/fulfilled",
  //       payload: { accessToken: storedToken },
  //     });
  //     navigate("/");
  //   }
  // }, [dispatch, navigate]);

  function submitRegister(values) {
    dispatch(register(values)).then((response) => {
      // Check if registration was successful and handle accordingly
      if (response.payload.accessToken) {
        // Store user token locally
        localStorage.setItem("accessToken", response.payload.accessToken);
        // Optionally store first name and last name if needed
        localStorage.setItem("firstName", values.firstName);
        localStorage.setItem("lastName", values.lastName);
        localStorage.setItem("email", values.email);
        // Redirect to home page
        navigate("/");
      }
    });
  }

  const validationSchema = Yup.object({
    firstName: Yup.string()
      .min(3, "Name must be at least 3 characters")
      .required("First Name is required"),
    lastName: Yup.string()
      .min(3, "Name must be at least 3 characters")
      .required("Last Name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string()
      .min(7, "Password must be at least 8 characters")
      .required("Password is required"),
  });

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: submitRegister,
  });

  return (
    <>
      <section className="outter">
        <div
          id="rlr_banner_slider"
          className="splide rlr-banner-splide rlr-banner-splide--fullwidth-v2"
        >
          <div className="splide__track rlr-banner-splide__track">
            <ul className="splide__list height-internal-pages">
              <li className="splide__slide height-internal-pages rlr-banner-splide__slide">
                <div className="rlr-banner-splide__image-wrapper height-internal-pages">
                  <div className="overlay-banner mb-0"></div>
                  <Suspense fallback={<div>Loading...</div>}>
                    <img src="/banner1.jpg" alt="login page" loading="lazy" />
                  </Suspense>
                </div>
                <article className=" rlr-banner-splide__content-wrapper container">
                  <div className="row justify-content-start">
                    <div className="col-xl-9">
                      <div className="rlr-banner-splide__header">
                        <h2
                          className="rlr-banner-splide__slogan rlr-section__title--main"
                          style={{ textShadow: "1px 1px 2px #000" }}
                        >
                          Sign Up
                        </h2>
                      </div>
                    </div>
                  </div>
                </article>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <main id="rlr-main" className="rlr-main--fixed-top py-5 my-5">
        <div
          className="rlr-section__content--lg-top mt-0"
          style={{ marginTop: "0px !important" }}
        >
          <section
            className="rlr-section rlr-section__mt rlr-account mt-0"
            style={{ marginTop: "0px !important" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-4 offset-lg-4">
                  <div className="rlr-authforms">
                    <div className="rlr-authforms__header mb-5">
                      <h2>Create an account </h2>
                      <p>Helps to access all features of the site. </p>
                    </div>
                    <form onSubmit={formik.handleSubmit} id="my-form">
                      <div className="rlr-authforms__form">
                        <div className="rlr-authforms__inputgroup">
                          <label className="rlr-form-label rlr-form-label--light required">
                            First Name
                          </label>
                          <input
                            type="text"
                            name="firstName"
                            id="firstName"
                            autoComplete="off"
                            required
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.firstName}
                            className="form-control form-control--light"
                          />
                          {formik.touched.firstName &&
                          formik.errors.firstName ? (
                            <p className="help-text">
                              {formik.errors.firstName}
                            </p>
                          ) : null}
                        </div>
                        <div className="rlr-authforms__inputgroup">
                          <label className="rlr-form-label rlr-form-label--light required">
                            Last Name
                          </label>
                          <input
                            type="text"
                            name="lastName"
                            id="lastName"
                            autoComplete="off"
                            required
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.lastName}
                            className="form-control form-control--light"
                          />
                        </div>
                        {formik.touched.lastName && formik.errors.lastName ? (
                          <p className="help-text">{formik.errors.lastName}</p>
                        ) : null}
                        <div className="rlr-authforms__inputgroup">
                          <label className="rlr-form-label rlr-form-label--light required">
                            Email
                          </label>
                          <input
                            type="email"
                            name="email"
                            id="email"
                            autoComplete="off"
                            required
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.email}
                            className="form-control form-control--light"
                          />
                          {formik.touched.email && formik.errors.email ? (
                            <p className="help-text">{formik.errors.email}</p>
                          ) : null}
                        </div>
                        <div className="rlr-authforms__inputgroup ">
                          <label className="rlr-form-label rlr-form-label--light required">
                            Password
                          </label>
                          <div className="d-flex align-items-center">
                            <input
                              type={passwordType}
                              name="password"
                              autoComplete="off"
                              required
                              minLength="8"
                              className="form-control form-control--light"
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.password}
                            />
                            <i
                              className="fa fa-eye"
                              id="togglePassword"
                              onClick={() =>
                                passwordType === "password"
                                  ? setPasswordType("text")
                                  : setPasswordType("password")
                              }
                              style={{ marginLeft: "-30px", cursor: "pointer" }}
                            ></i>
                          </div>
                          <p className="help-text">
                            Must be 8 charachters or more
                          </p>
                        </div>

                        <div className="rlr-authforms__inputgroup">
                          <label className="rlr-form-label rlr-form-label--light required">
                            Confirm Password
                          </label>
                          <div className="d-flex align-items-center">
                            <input
                              type={repasswordType}
                              id="confirmpassword"
                              required
                              autoComplete="off"
                              value={rePass}
                              onChange={(e) => setRePass(e.target.value)}
                              minLength="8"
                              className="form-control form-control--light"
                            />
                            <i
                              className="fa fa-eye"
                              id="toggleconfirmpassword"
                              onClick={() =>
                                repasswordType === "password"
                                  ? setRepasswordType("text")
                                  : setRepasswordType("password")
                              }
                              style={{ marginLeft: "-30px", cursor: "pointer" }}
                            ></i>
                          </div>
                          {rePass !== formik.values.password && (
                            <p className="text-danger" hidden="" id="notMatch">
                              Passwords do not match!
                            </p>
                          )}
                        </div>

                        {message !== null && (
                          <p className="help-text text-danger text-center fw-bold">
                            {message}
                          </p>
                        )}

                        <button
                          type="submit"
                          className="btn rlr-button rlr-button--fullwidth rlr-button--primary"
                        >
                          Sign Up
                        </button>

                        {/* <button
                          type="button"
                          id="googleSignInButton"
                          style={{ cursor: "pointer" }}
                          className="btn mb-3 rlr-button rlr-button--fullwidth rlr-button--google"
                        >
                          Sign in with Google
                        </button> */}
                        <GoogleLogin
                          clientId={clientId}
                          buttonText="Sign in with Google"
                          onSuccess={onSuccess}
                          onFailure={onFailure}
                          cookiePolicy={"single_host_origin"}
                          isSignedIn={false}
                          className="btn mb-3 rlr-button rlr-button--fullwidth text-dark fw-bold fs-4 google"
                          id="googleSignInButton"
                        />
                      </div>
                    </form>

                    <div className="rlr-authforms__notes">
                      <p>
                        Already have an account?
                        <Link to="/login">Log in </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}

export default SignUp;
